module.exports = __webpack_public_path__ + "static/media/our-vision.2a1c8d8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/our-vision.jpg
// module id = 502
// module chunks = 33